/**
 * Single-Product Customizer (Bundy-Style Layout)
 * ================================================
 * Handles the single-product engraving flow with front/back
 * support, gallery, text, and upload options.
 * Scoped to .sc_popup to avoid conflicts.
 */

$(document).ready(function () {
  // Only run when the single customizer popup exists (and NOT on Bundy)
  if (!$(".sc_popup")[0]) return;
  if ($(".popup_bundy_customizer")[0]) return;

  var FONT_CLASSES = "font-Manderley font-Crosterian font-Whiphand font-Socialist";

  // State — text and logo are tracked independently; getSideType() computes the combined type
  var scState = {
    activeSide: "front", // 'front' or 'back'
    front: { text: "", font: "Manderley", logoUrl: "", logoName: "", logoThumb: "" },
    back: { text: "", font: "Manderley", logoUrl: "", logoName: "", logoThumb: "" },
    activeColour: "",
    variantId: ""
  };

  // Compute the effective type for a side: "", "text", "logo", or "both"
  function getSideType(side) {
    var s = scState[side];
    if (s.text && s.logoUrl) return "both";
    if (s.text) return "text";
    if (s.logoUrl) return "logo";
    return "";
  }

  var sizeTag = $(".sc_popup").attr("data-sizetag") || "";
  var disableGallery = $(".sc_popup").attr("data-disable-gallery") === "true";

  // Single source of truth for whether "Choose a Design" is available for a
  // given colour — per-variant custom.disable_gallery_variants metafield
  // (data-gallery), falling back to the product-level disableGallery flag.
  // Keeps the selection menu, colour-swatch change, and review screen in
  // sync instead of each re-deriving it (and drifting, as the review screen
  // previously did by bypassing this check entirely).
  function isGalleryDisabledForColour(colorHandle) {
    var variantData = colorHandle ? $(".sc_variant_data[data-color='" + colorHandle + "']").first() : $();
    if (variantData.length && variantData.attr("data-gallery") === "true") return true;
    return disableGallery;
  }

  function syncGalleryAvailability(colorHandle) {
    var disabled = isGalleryDisabledForColour(colorHandle);
    if (disabled) {
      $(".sc_gallery_option").hide();
      $('.sc_review_slot[data-slot="design"]').hide();
    } else {
      $(".sc_gallery_option").show();
      $('.sc_review_slot[data-slot="design"]').show();
    }
    return disabled;
  }

  // If wine, default to back only
  if (sizeTag === "wine") {
    scState.activeSide = "back";
  }

  // ==========================================
  // Engravable area — drives real logo/text placement (see
  // dtc-area-personalization skill). Ratios are fractions of each side's
  // own rendered .sc_main_image box, computed per side so front/back
  // never borrow each other's geometry.
  // ==========================================
  var AREA_RATIOS = {
    "950ml": { w: 0.14, h: 0.2394, t: 0.3686 }, // 1L
    "1-9l":  { w: 0.15, h: 0.227, t: 0.401 },  // 2L
    // Starting placeholders — not yet visually calibrated (see
    // dtc-area-personalization skill, "Procedure: adding a new size").
    "4l":    { w: 0.20, h: 0.325, t: 0.415 },  // 4L — default (Navy, Charcoal, Teal, Black, Green, Stainless Steel, Stone, Blue, Black Char, Lavender, Pink) — calibrated
    "6l":    { w: 0.20, h: 0.4125, t: 0.33125 }, // 6L — same rule for every colour
    "stubby": { w: 0.25, h: 0.45, t: 0.22 } // Stubby Holder
  };

  // Some sizes have more than one product photo batch with different
  // bottle framing — same sizeTag, but the ratios above don't fit every
  // colour. Not derived from any metafield (customizer_texture_image looks
  // similar but isn't reliable for this) — a manual mapping maintained by
  // whoever's driving colour additions/re-shoots. Falls back to
  // AREA_RATIOS[sizeTag] for any colour not listed here.
  var AREA_RATIOS_BY_COLOUR = {
    "4l": {
      "bundaberg-rum": { w: 0.20, h: 0.30, t: 0.515 }
      // Pink, Blue, Black Char, Lavender all moved into the 4L default
      // group above — Pink was the last one still on this override.
    }
  };

  function currentAreaRatios() {
    var override = AREA_RATIOS_BY_COLOUR[sizeTag] && AREA_RATIOS_BY_COLOUR[sizeTag][scState.activeColour];
    return override || AREA_RATIOS[sizeTag];
  }

  // Sizes whose real logo/text placement reads from the area instead of
  // the legacy independent top% CSS.
  var AREA_DRIVEN_SIZES = { "1-9l": true, "950ml": true, "4l": true, "6l": true, "stubby": true }; // 2L, 1L, 4L, 6L, Stubby

  // Laser height convention: a design/logo should never be taller than
  // 1.5x its own width, independent of how tall the area box is.
  var MAX_HEIGHT_RATIO = 1.15;

  // Pure function of "whatever image is rendered right now" — no cached
  // state. Works identically for the live front/back previews and for any
  // clone (e.g. the confirm popup thumbnail).
  //
  // Deliberately uses offsetWidth/offsetHeight/offsetLeft/offsetTop (layout
  // geometry) instead of getBoundingClientRect() (rendered/post-transform
  // geometry). CSS left/top on a child are interpreted in the PARENT's
  // local/untransformed space, then the whole subtree gets transformed
  // together — so if we measured with getBoundingClientRect() on a
  // transform:scale()'d ancestor (like the confirm popup clone), we'd be
  // feeding already-scaled pixel diffs back in as left/top, and the
  // ancestor's transform would scale them AGAIN. Layout geometry sidesteps
  // that entirely since it's transform-agnostic, matching the coordinate
  // space CSS left/top actually use.
  function getAreaBox($preview, $img) {
    var r = currentAreaRatios();
    if (!$img.length || !r) return null;
    var img = $img[0];
    var iw = img.offsetWidth, ih = img.offsetHeight;
    if (!iw || !ih) return null;
    var offsetLeft = 0, offsetTop = 0, node = img, guard = 0;
    while (node && node !== $preview[0] && guard++ < 20) {
      offsetLeft += node.offsetLeft;
      offsetTop += node.offsetTop;
      node = node.offsetParent;
    }
    var w = iw * r.w, h = ih * r.h;
    var left = offsetLeft + (iw - w) / 2;
    var top = offsetTop + ih * r.t;
    return { left: left, top: top, width: w, height: h, centerX: left + w / 2, bottom: top + h };
  }

  // Debug boundary — a boolean gate kept in code (not a theme setting),
  // toggled by editing this line + committing. Shows a dashed box around
  // the current AREA_RATIOS box for live calibration.
  var SHOW_DEBUG_AREA = false;

  function positionBoundaryFor($preview, $img, $box) {
    if (!SHOW_DEBUG_AREA) { $box.hide(); return; }
    var area = getAreaBox($preview, $img);
    if (!$box.length || !area) { $box.hide(); return; }
    $box.css({ display: "block", width: area.width + "px", height: area.height + "px", left: area.left + "px", top: area.top + "px" });
  }

  // Sets each prop with priority "important" so it wins over the legacy
  // per-size !important CSS (top/max-width/max-height are declared
  // !important all over customizer-dtc.css for cstsize_1-9l — an inline
  // !important beats an external-stylesheet !important regardless of
  // selector specificity, so this sidesteps hunting down every old rule).
  function setImportant($el, props) {
    $el.each(function () {
      for (var prop in props) {
        this.style.setProperty(prop, props[prop], "important");
      }
    });
  }

  // Text is never width-clamped or font-shrunk: the laser engraves at a
  // fixed size per font and longer names span wider on the bottle. Clears
  // the inline clamp/shrink styles the brief clipping-era code set, so
  // overlays recover on the next reposition.
  function bbClearTextClamp($overlay, $textEl) {
    $overlay.each(function () {
      this.style.removeProperty("max-width");
      this.style.removeProperty("overflow");
    });
    $textEl.each(function () { this.style.removeProperty("font-size"); });
  }

  // Places the actual logo/text against the area box, per the 3 cases:
  // text-only, logo-only, both. Only runs for AREA_DRIVEN_SIZES — other
  // sizes keep using their legacy independent top% CSS untouched.
  function positionPersonalizationFor($preview, $img, side) {
    if (!AREA_DRIVEN_SIZES[sizeTag]) return;
    var area = getAreaBox($preview, $img);
    if (!area) return;
    var $textOverlay = $preview.find(".sc_text_overlay");
    var $textEl = $preview.find(".sc_textup");
    var $logoOverlay = $preview.find(".sc_logo_overlay");
    var $logoImg = $preview.find(".sc_logo_img");
    // Based on what's actually visible right now, not scState — scState.logoUrl
    // only gets set when the user hits the gallery's "Apply" button, but the
    // overlay itself becomes visible as soon as they click a gallery item
    // (live preview before confirming). Keying off scState here meant the
    // design rendered at its old/default size during that live-preview
    // window and only snapped to the real area-driven size after Apply —
    // a visible jump right when Apply is supposed to just confirm what's
    // already on screen.
    var hasText = $textOverlay.length && !$textOverlay.hasClass("hide");
    var hasLogo = $logoOverlay.length && !$logoOverlay.hasClass("hide");
    var type = hasText && hasLogo ? "both" : hasText ? "text" : hasLogo ? "logo" : "";

    if (type === "logo") {
      // Solo diseño: centered in the area, contained within it (aspect ratio preserved).
      // Height is additionally capped at 1.5x the width — laser convention,
      // independent of how tall the area box itself happens to be, so a
      // narrow/tall logo can't eat up the full area height.
      var logoMaxH = Math.min(area.height, area.width * MAX_HEIGHT_RATIO);
      setImportant($logoOverlay, { left: area.centerX + "px", top: (area.top + area.height / 2) + "px", transform: "translate(-50%, -50%)" });
      setImportant($logoImg, { "max-width": area.width + "px", "max-height": logoMaxH + "px" });
    } else if (type === "text") {
      // Solo texto: anchored to the top of the area (same rule as the
      // "both" case below), width capped to the area's width.
      // Text renders at its font's fixed calibrated size: the laser engraves
      // at a fixed size and longer names simply span wider on the bottle, so
      // no width clamp and no shrink-to-fit (Kegan, 11 Aug 2026).
      bbClearTextClamp($textOverlay, $textEl);
      var soloTextH = $textEl.length ? $textEl[0].offsetHeight : 0;
      setImportant($textOverlay, { left: area.centerX + "px", top: (area.top + soloTextH / 2) + "px", transform: "translate(-50%, -50%)" });
    } else if (type === "both") {
      // Text keeps the same placement rule as solo-texto, anchored to the
      // top of the area so the logo has room below it.
      bbClearTextClamp($textOverlay, $textEl);
      var textH = $textEl.length ? $textEl[0].offsetHeight : 0;
      var textTop = area.top;
      setImportant($textOverlay, { left: area.centerX + "px", top: (textTop + textH / 2) + "px", transform: "translate(-50%, -50%)" });

      // Logo fills the remaining space below the text, with a padding gap
      // that's mirrored between logo↔text and logo↔area-bottom-edge so the
      // logo sits centered within its own slice of remaining space.
      // First-pass padding ratio — adjust after visual check, same as the area itself.
      var remaining = area.bottom - (textTop + textH);
      var pad = remaining * 0.12;
      var logoH = Math.min(Math.max(remaining - pad * 2, 0), area.width * MAX_HEIGHT_RATIO);
      var logoCenterY = textTop + textH + pad + logoH / 2;
      setImportant($logoOverlay, { left: area.centerX + "px", top: logoCenterY + "px", transform: "translate(-50%, -50%)" });
      setImportant($logoImg, { "max-width": area.width + "px", "max-height": logoH + "px" });
    }
  }

  function positionBoundary() {
    ["front", "back"].forEach(function (side) {
      var $preview = $(".sc_" + side + "_preview");
      var $img = $preview.find(".sc_main_image");
      positionBoundaryFor($preview, $img, $preview.find(".sc_boundary"));
      positionPersonalizationFor($preview, $img, side);
    });
  }

  // Call after any content change (text typed, logo picked/cleared, font
  // changed) on the currently active side — the area itself doesn't move,
  // but which case applies (text/logo/both) and the text's own rendered
  // width/height can.
  function refreshActivePersonalization() {
    var side = scState.activeSide;
    var $preview = $(".sc_" + side + "_preview");
    positionPersonalizationFor($preview, $preview.find(".sc_main_image"), side);
  }

  // Two passes: 50ms (fast path) and 450ms — .sc_product_preview has
  // transition: all .3s, so layout changes (review mode, tab switch) are
  // still animating at 50ms and a single early measure can freeze the
  // overlay at mid-transition geometry (seen on iOS Safari, where the
  // ResizeObserver backstop is less reliable than Chrome's).
  function positionBoundarySoon() {
    setTimeout(positionBoundary, 50);
    setTimeout(positionBoundary, 450);
  }

  // Recompute a side whenever its image actually finishes loading — covers
  // colour-swap src loads on slow connections and freshly-appended confirm
  // clones, where a synchronous measure sees a 0-height image and bails,
  // leaving the overlay wherever it last was. 'load' doesn't bubble, so
  // listen in the capture phase.
  document.addEventListener("load", function (e) {
    var img = e.target;
    if (!img || !img.classList || !img.classList.contains("sc_main_image")) return;
    var $preview = $(img).closest(".sc_product_preview");
    if (!$preview.length) return;
    var side = $preview.hasClass("sc_front_preview") ? "front" : "back";
    positionBoundaryFor($preview, $(img), $preview.find(".sc_boundary"));
    positionPersonalizationFor($preview, $(img), side);
  }, true);

  // Auto-recompute whenever an observed image's rendered size actually
  // changes — tab switch (hidden→shown), review mode, breakpoint shifts,
  // window resize — without having to remember a setTimeout at every call
  // site that touches the layout. (Doesn't fire on scale()-only transforms,
  // since those don't change layout size — the confirm-popup clone calls
  // positionPersonalizationFor() directly instead.)
  var boundaryResizeObserver = ("ResizeObserver" in window) ? new ResizeObserver(function (entries) {
    entries.forEach(function (entry) {
      var $img = $(entry.target);
      var $preview = $img.closest(".sc_product_preview");
      var side = $preview.hasClass("sc_front_preview") ? "front" : "back";
      positionBoundaryFor($preview, $img, $preview.find(".sc_boundary"));
      positionPersonalizationFor($preview, $img, side);
    });
  }) : null;

  function observeBoundaryImage($img) {
    if (boundaryResizeObserver && $img.length) { boundaryResizeObserver.observe($img[0]); }
  }

  observeBoundaryImage($(".sc_front_preview .sc_main_image"));
  observeBoundaryImage($(".sc_back_preview .sc_main_image"));

  // Fallback for browsers without ResizeObserver / edge cases it can't catch.
  $(window).on("resize", positionBoundary);

  // ==========================================
  // OPEN CUSTOMIZER
  // ==========================================
  $(document).on("click", ".customise_button", function () {
    // Don't intercept if Bundy popup exists
    if ($(".popup_bundy_customizer")[0]) return;
    if (!$(".sc_popup")[0]) return;
    /* Variant has customisation disabled */
    var _vcVarId = scState.variantId || $(".sc_variant_data").first().attr("data-variant-id");
    if (window.variantCustomisable && window.variantCustomisable[String(_vcVarId)]) { return; }

    // Hide the standard customizer if it exists
    $(".popup_pd_customizer").removeClass("active");

    // Reset state
    scState.front = { text: "", font: "Manderley", logoUrl: "", logoName: "", logoThumb: "" };
    scState.back = { text: "", font: "Manderley", logoUrl: "", logoName: "", logoThumb: "" };
    if (sizeTag === "wine") {
      scState.activeSide = "back";
    } else {
      scState.activeSide = "front";
    }

    // Reset UI
    resetScUI();

    // Sync colour from the product page
    syncColourFromPage();

    // Check gallery disable for the initially active variant
    var activeColor = $(".sc_colour_swatch.active").attr("data-color");
    syncGalleryAvailability(activeColor);

    // Show popup
    $("body").addClass("sc_customizer_active");
    $(".sc_popup").addClass("active");
    positionBoundarySoon();
  });

  // ==========================================
  // CLOSE CUSTOMIZER
  // ==========================================
  $(document).on("click", ".sc_close_btn", function () {
    $(".sc_popup").removeClass("active");
    $("body").removeClass("sc_customizer_active");
  });

  // Close on overlay click
  $(document).on("click", ".sc_popup", function (e) {
    if ($(e.target).hasClass("sc_popup")) {
      $(".sc_popup").removeClass("active");
      $("body").removeClass("sc_customizer_active");
    }
  });

  // ==========================================
  // COLOUR SWATCH SELECTION
  // ==========================================
  $(document).on("click", ".sc_colour_swatch", function () {
    $(".sc_colour_swatch").removeClass("active");
    $(this).addClass("active");

    var colorHandle = $(this).attr("data-color");
    var colorName = $(this).attr("data-name");
    scState.activeColour = colorHandle;

    // Update colour name display
    $(".sc_selected_colour_name").text(colorName.split(" - ")[0]);
    $(".sc_selected_colour_name_inline").text(colorName.split(" - ")[0]);

    // Update variant name
    $(".sc_variant_name").text(colorName);

    // Find matching variant data and update images
    var variantData = $(".sc_variant_data[data-color='" + colorHandle + "']").first();
    if (variantData.length) {
      var frontSrc = variantData.attr("data-front");
      var backSrc = variantData.attr("data-back");
      var textureUrl = variantData.attr("data-texture");
      scState.variantId = variantData.attr("data-variant-id");

      if (frontSrc) $(".sc_front_image").attr("src", frontSrc);
      if (backSrc) $(".sc_back_image").attr("src", backSrc);
      if (textureUrl) {
        $(".sc_textup").css("background-image", 'url("' + textureUrl + '")');
      }

      // Colour change can switch which area ratios apply (see
      // AREA_RATIOS_BY_COLOUR — some sizes have more than one photo batch)
      // even when the image box's own pixel size doesn't change, so this
      // can't rely on the ResizeObserver alone.
      positionBoundary();
      positionBoundarySoon();

      // Also sync the main product page colour swatch
      var mainSwatch = $(".color_items[data-color='" + colorHandle + "']");
      if (mainSwatch.length && !mainSwatch.hasClass("active")) {
        mainSwatch.trigger("click");
      }

      // Check gallery disable state for this variant
      syncGalleryAvailability(colorHandle);
    }
  });

  // ==========================================
  // TAB SWITCHING (Front/Back)
  // ==========================================
  $(document).on("click", ".sc_tab_front", function () {
    saveCurrentSideState();
    scState.activeSide = "front";
    $(".sc_tab").removeClass("active");
    $(this).addClass("active");
    $(".sc_front_preview").addClass("active");
    $(".sc_back_preview").removeClass("active");
    restoreSideState("front");
    goToSelectionMenu();
    positionBoundarySoon();
  });

  $(document).on("click", ".sc_tab_back", function () {
    saveCurrentSideState();
    scState.activeSide = "back";
    $(".sc_tab").removeClass("active");
    $(this).addClass("active");
    $(".sc_back_preview").addClass("active");
    $(".sc_front_preview").removeClass("active");
    restoreSideState("back");
    goToSelectionMenu();
    positionBoundarySoon();
  });

  // ==========================================
  // GALLERY OPTION
  // ==========================================
  $(document).on("click", ".sc_gallery_option", function () {
    $(".sc_selection_menu").addClass("hide");
    $(".sc_gallery_section").removeClass("hide");
    $(".sc_text_section").addClass("hide");
    $(".sc_skip_review_btn").addClass("hide");
    $(".sc_menu_review_btn").addClass("hide");
    // Show categories, hide items
    $(".sc_gallery_categories").removeClass("hide");
    $(".sc_gallery_items").addClass("hide");
  });

  // Gallery category click
  $(document).on("click", ".sc_gallery_cat", function () {
    var cat = $(this).attr("data-cat");
    $(".sc_gallery_categories").addClass("hide");
    $(".sc_gallery_items").removeClass("hide");
    $(".sc_gallery_section > .sc_back_btn").addClass("hide");
    $(".sc_cat_content").addClass("hide");
    $(".sc_cat_" + cat).removeClass("hide");
    // Reset selection
    $(".sc_cat_content .image").removeClass("active");
    $(".sc_search_input").val("");
    $(".sc_cat_content .logo-item-detail").show();
  });

  // Gallery back to categories
  $(document).on("click", ".sc_gallery_back_btn", function () {
    $(".sc_gallery_items").addClass("hide");
    $(".sc_gallery_categories").removeClass("hide");
    $(".sc_gallery_section > .sc_back_btn").removeClass("hide");
  });

  // Gallery search
  $(document).on("keyup", ".sc_search_input", function () {
    var query = $(this).val().toLowerCase();
    $(".sc_cat_content:not(.hide) .logo-item-detail").each(function () {
      var name = $(this).find(".prepared-item-title").text().toLowerCase();
      if (name.indexOf(query) >= 0 || query === "") {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  });

  // Gallery logo selection — show logo overlay WITHOUT hiding text overlay
  $(document).on("click", ".sc_cat_content .image", function () {
    $(".sc_cat_content .image").removeClass("active");
    $(this).addClass("active");
    $(".sc_preview_gallery").removeAttr("disabled");
    $(".sc_preview_gallery_top").removeAttr("disabled");
    $(".sc_gallery_nav_top").addClass("active").removeClass("hide");
    $(".sc_clear_gallery").removeAttr("disabled");

    var logoSrc = $(this).attr("data-texture") || $(this).find("img").attr("src");
    var logoName = $(this).closest(".logo-item-detail").find(".prepared-item-title").text().trim();

    // Update preview — show logo but leave text overlay as-is
    var activePreview = scState.activeSide === "front" ? ".sc_front_preview" : ".sc_back_preview";
    $(activePreview + " .sc_logo_overlay").removeClass("hide");
    $(activePreview + " .sc_logo_img").attr("src", logoSrc);
    $(activePreview + " .sc_uploadingimg").hide();
    refreshActivePersonalization();
  });

  // Gallery preview/review — save logo without clearing text
  $(document).on("click", ".sc_preview_gallery, .sc_preview_gallery_top", function () {
    var activeLogo = $(".sc_cat_content .image.active");
    if (!activeLogo.length) return;

    var logoSrc = activeLogo.attr("data-texture") || activeLogo.find("img").attr("src");
    var logoName = activeLogo.closest(".logo-item-detail").find(".prepared-item-title").text().trim();

    scState[scState.activeSide].logoUrl = logoSrc;
    scState[scState.activeSide].logoName = logoName;
    scState[scState.activeSide].logoThumb = activeLogo.find("img").attr("src") || logoSrc;
    // text and font are left untouched

    refreshActivePersonalization();
    checkAndShowReview();
  });

  // Clear gallery — only clears logo state, leaves text intact
  $(document).on("click", ".sc_clear_gallery, .sc_clear_gallery_top", function () {
    $(".sc_cat_content .image").removeClass("active");
    $(".sc_preview_gallery").attr("disabled", "disabled");
    $(".sc_preview_gallery_top").attr("disabled", "disabled");
    $(".sc_gallery_nav_top").removeClass("active").addClass("hide");
    $(".sc_clear_gallery").attr("disabled", "disabled");
    scState[scState.activeSide].logoUrl = "";
    scState[scState.activeSide].logoName = "";
    scState[scState.activeSide].logoThumb = "";
    // text state is left untouched

    var activePreview = scState.activeSide === "front" ? ".sc_front_preview" : ".sc_back_preview";
    $(activePreview + " .sc_logo_overlay").addClass("hide");
    $(activePreview + " .sc_logo_img").attr("src", "");
    refreshActivePersonalization();
  });

  // Grow or shrink font-size on each pill to fill available content box width.
  // Range API is unreliable on flex containers — we wrap text in an inner span once so we
  // can measure it directly via getBoundingClientRect().
  function fitFontItems() {
    // Ensure each pill has a measurable inner span (idempotent — only wraps once)
    $('.sc_font_item').each(function () {
      if (!$(this).children('.sc-fw').length) {
        $(this).wrapInner('<span class="sc-fw" style="pointer-events:none;white-space:nowrap;display:inline-block"></span>');
      }
    });

    $('.sc_font_item').each(function () {
      var el = this;
      var inner = el.querySelector('.sc-fw');
      el.style.fontSize = ''; // reset to CSS base
      var cs = getComputedStyle(el);
      var size = parseFloat(cs.fontSize);
      var padH = parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight);
      var maxW = el.clientWidth - padH; // content box width (3px clearance each side)

      if (maxW <= 0) return; // element not yet visible — skip

      function textW() {
        return inner.getBoundingClientRect().width;
      }

      // Grow while there is room (cap at 24px)
      while (textW() < maxW - 8 && size < 24) {
        size += 0.5;
        el.style.fontSize = size + 'px';
      }
      // Pull back if we overshot
      while (textW() > maxW && size > 6) {
        size -= 0.5;
        el.style.fontSize = size + 'px';
      }
    });
  }

  function fitFontItemsWhenReady() {
    // rAF ensures layout has settled after the section becomes visible
    requestAnimationFrame(function () {
      fitFontItems();
      // Re-run after fonts load — custom fonts render async, first pass uses fallback metrics
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () {
          requestAnimationFrame(fitFontItems);
        });
      } else {
        setTimeout(fitFontItems, 300);
      }
    });
  }

  // ==========================================
  // TEXT OPTION
  // ==========================================
  $(document).on("click", ".sc_text_option", function () {
    $(".sc_selection_menu").addClass("hide");
    $(".sc_text_section").removeClass("hide");
    $(".sc_gallery_section").addClass("hide");
    $(".sc_skip_review_btn").addClass("hide");
    $(".sc_menu_review_btn").addClass("hide");
    fitFontItemsWhenReady();

    // Restore existing text for this side (regardless of whether logo is also set)
    var state = scState[scState.activeSide];
    if (state.text) {
      $(".sc_text_input").val(state.text);
      $(".sc_text_input").removeClass(FONT_CLASSES).addClass("font-" + state.font);
      $(".sc_font_item").removeClass("active");
      $(".sc_font_item[data-font='" + state.font + "']").addClass("active");
      $(".sc_preview_text").removeAttr("disabled");
    } else {
      $(".sc_text_input").val("");
      $(".sc_text_input").removeClass(FONT_CLASSES).addClass("font-Manderley");
      $(".sc_font_item").removeClass("active");
      $(".sc_font_item[data-font='Manderley']").addClass("active");
      $(".sc_preview_text").attr("disabled", "disabled");
    }
  });

  // Text input handling
  var RE_EMOJI = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g;
  var RE_SPECIAL = /[^a-zA-Z0-9\s]/g;

  // Fix iOS Safari zoom: reset viewport after keyboard dismissal
  $(document).on("blur", ".sc_text_input", function () {
    if (/iPhone|iPad|iPod/.test(navigator.userAgent)) {
    setTimeout(function () {
        window.scrollTo(0, 0);
        document.body.style.zoom = 1;
      }, 100);
    }
  });

  $(document).on("keyup keydown change paste input", ".sc_text_input", function (event) {
    if (event.key === "Enter") {
      event.preventDefault();
      return false;
    }

    var $elem = $(this);
    var content = $elem.val();

    // Remove emojis and special characters
    if (RE_EMOJI.test(content) || RE_SPECIAL.test(content)) {
      content = content.replace(RE_EMOJI, "").replace(RE_SPECIAL, "");
      $elem.val(content);
    }

    var valLength = content.length;
    var maxSize = parseInt($elem.attr("data-size")) || 10;

    if (valLength > maxSize) {
      $(".sc_char_warning").removeClass("hide");
      $(".sc_preview_text").attr("disabled", "disabled");
    } else {
      $(".sc_char_warning").addClass("hide");
      if (valLength > 0) {
        $(".sc_preview_text").removeAttr("disabled");
      } else {
        $(".sc_preview_text").attr("disabled", "disabled");
      }
    }

    // Update preview
    updateActivePreviewText(content);
  });

  // Font selection
  $(document).on("click", ".sc_font_item", function () {
    $(".sc_font_item").removeClass("active");
    $(this).addClass("active");
    var font = $(this).attr("data-font");
    $(".sc_text_input").removeClass(FONT_CLASSES).addClass("font-" + font);

    // Update preview font
    var activePreview = scState.activeSide === "front" ? ".sc_front_preview" : ".sc_back_preview";
    $(activePreview + " .sc_textup").removeClass(FONT_CLASSES).addClass("font-" + font);
    refreshActivePersonalization();
  });

  // Text preview/review button — saves text without clearing logo
  $(document).on("click", ".sc_preview_text", function () {
    var text = $(".sc_text_input").val().trim();
    var font = $(".sc_font_item.active").attr("data-font");

    scState[scState.activeSide].text = text;
    scState[scState.activeSide].font = font;
    // logoUrl and logoName are left untouched

    updateActivePreviewText(text);
    var activePreview = scState.activeSide === "front" ? ".sc_front_preview" : ".sc_back_preview";
    $(activePreview + " .sc_textup").removeClass(FONT_CLASSES).addClass("font-" + font);

    checkAndShowReview();
  });

  // Clear text — only clears text state, leaves logo intact
  $(document).on("click", ".sc_clear_text", function () {
    $(".sc_text_input").val("");
    $(".sc_preview_text").attr("disabled", "disabled");
    scState[scState.activeSide].text = "";
    // logoUrl/logoName are left untouched

    var activePreview = scState.activeSide === "front" ? ".sc_front_preview" : ".sc_back_preview";
    $(activePreview + " .sc_text_overlay").addClass("hide");
    $(activePreview + " .sc_textup").html("");
    // logo overlay is left untouched
    refreshActivePersonalization();
  });

  // Back buttons — save current state before navigating away
  $(document).on("click", ".sc_back_btn", function () {
    saveCurrentSideState();
    goToSelectionMenu();
  });

  // Go Back from review/add-to-cart screen
  $(document).on("click", ".sc_review_back_nav", function () {
    // Hide the review section, show the customizer again
    $(".sc_addtocart_section").addClass("hide");
    $(".sc_customize_section").removeClass("hide");
    $(".sc_tabs").removeClass("hide");
    $(".sc_outer_box").removeClass("sc_review_mode");

    // Restore the active side tab and preview
    if (scState.activeSide === "back") {
      $(".sc_tab").removeClass("active");
      $(".sc_tab_back").addClass("active");
      $(".sc_back_preview").addClass("active");
      $(".sc_front_preview").removeClass("active");
    } else {
      $(".sc_tab").removeClass("active");
      $(".sc_tab_front").addClass("active");
      $(".sc_front_preview").addClass("active");
      $(".sc_back_preview").removeClass("active");
    }

    // Go to the selection menu
    goToSelectionMenu();
  });

  // ==========================================
  // REVIEW & ADD TO CART
  // ==========================================


  // Handle click on the selection menu Review button
  $(document).on("click", ".sc_menu_review_btn", function () {
    saveCurrentSideState();
    updateReviewSummary();
    showAddToCart();
  });

  function checkAndShowReview() {
    var frontHas = getSideType("front") !== "";
    var backHas = getSideType("back") !== "";
    var isWine = sizeTag === "wine";

    updateReviewSummary();

    if (isWine && backHas) {
      // Wine only has back - go straight to review
      $(".sc_skip_review_btn").addClass("hide");
      showAddToCart();
    } else if (frontHas && backHas) {
      // Both sides done - go straight to review
      $(".sc_skip_review_btn").addClass("hide");
      showAddToCart();
    } else if (frontHas || backHas) {
      // Only one side done — stay on current side, show Review button
      // Let the customer choose to add the other side or skip to review
      goToSelectionMenu();
      $(".sc_skip_review_btn").removeClass("hide");
    }
  }

  // Scale text slots horizontally to fit single line (called after section is visible)
  function fitSlotTexts() {
    $('.sc_review_slot.active[data-slot="text"] .sc_slot_value').each(function () {
      var el = this;
      el.style.transform = '';
      if (el.scrollWidth > el.clientWidth) {
        el.style.transform = 'scaleX(' + (el.clientWidth / el.scrollWidth) + ')';
      }
    });
  }

  function showAddToCart() {
    $(".sc_addtocart_section").removeClass("hide");
    $(".sc_customize_section").addClass("hide");
    $(".sc_tabs").addClass("hide");
    $(".sc_skip_review_btn").addClass("hide");
    fitSlotTexts();

    var frontHas = getSideType("front") !== "";
    var backHas = getSideType("back") !== "";
    var isWine = sizeTag === "wine";

    // Only show the sides that have content
    if (isWine) {
      $(".sc_outer_box").removeClass("sc_review_mode");
      $(".sc_front_preview").removeClass("active");
      $(".sc_back_preview").addClass("active");
    } else if (frontHas && backHas) {
      // Both sides customized — expand layout, show both full size
      $(".sc_outer_box").addClass("sc_review_mode");
      $(".sc_front_preview").addClass("active");
      $(".sc_back_preview").addClass("active");
    } else if (frontHas) {
      $(".sc_outer_box").removeClass("sc_review_mode");
      $(".sc_front_preview").addClass("active");
      $(".sc_back_preview").removeClass("active");
    } else if (backHas) {
      $(".sc_outer_box").removeClass("sc_review_mode");
      $(".sc_front_preview").removeClass("active");
      $(".sc_back_preview").addClass("active");
    }
    positionBoundarySoon();
  }

  function updateReviewSummary() {
    // The review screen renders its own "Add design" CTA per side —
    // keep it gated the same as the selection menu's gallery option.
    syncGalleryAvailability(scState.activeColour);

    var unitPrice = parseFloat($('.sc_left_preview').data('price')) || 0;
    var cur = $('.sc_left_preview').data('cur') || '$';
    ['front', 'back'].forEach(function (side) {
      var s = scState[side];
      var priceStr = cur + unitPrice.toFixed(2);

      // Design slot
      var $dSlot = $('[data-side="' + side + '"][data-slot="design"]');
      if (s.logoUrl) {
        $dSlot.addClass('active');
        $dSlot.find('.sc_slot_value').html('<img src="' + (s.logoThumb || s.logoUrl) + '" alt="' + s.logoName + '">');
        $dSlot.find('.sc_slot_price').text(priceStr);
      } else {
        $dSlot.removeClass('active');
        $dSlot.find('.sc_slot_value').html('');
      }

      // Text slot
      var $tSlot = $('[data-side="' + side + '"][data-slot="text"]');
      if (s.text) {
        $tSlot.addClass('active');
        $tSlot.find('.sc_slot_value')
          .removeClass(FONT_CLASSES)
          .addClass('font-' + s.font)
          .text(s.text);
        $tSlot.find('.sc_slot_price').text(priceStr);
      } else {
        $tSlot.removeClass('active');
        $tSlot.find('.sc_slot_value').removeClass(FONT_CLASSES).css('transform', '');
      }
    });
  }

  // Navigate from review back to a specific side + section
  function navFromReview(side, slot) {
    // Guard against the design slot's own CTA, in case it's clicked before
    // updateReviewSummary() has hidden it (e.g. stale render) — the gallery
    // option must never open for a colour where it's disabled.
    if (slot === "design" && isGalleryDisabledForColour(scState.activeColour)) return;

    $(".sc_addtocart_section").addClass("hide");
    $(".sc_customize_section").removeClass("hide");
    $(".sc_tabs").removeClass("hide");
    $(".sc_outer_box").removeClass("sc_review_mode");
    scState.activeSide = side;
    $(".sc_tab").removeClass("active");
    $(".sc_tab_" + side).addClass("active");
    if (side === "back") {
      $(".sc_back_preview").addClass("active");
      $(".sc_front_preview").removeClass("active");
    } else {
      $(".sc_front_preview").addClass("active");
      $(".sc_back_preview").removeClass("active");
    }
    if (slot === "design") {
      $(".sc_gallery_option").trigger("click");
    } else {
      $(".sc_text_option").trigger("click");
    }
    positionBoundarySoon();
  }

  $(document).on("click", ".sc_slot_edit", function (e) {
    e.stopPropagation();
    var $slot = $(this).closest(".sc_review_slot");
    navFromReview($slot.data("side"), $slot.data("slot"));
  });

  $(document).on("click", ".sc_slot_empty", function () {
    var $slot = $(this).closest(".sc_review_slot");
    navFromReview($slot.data("side"), $slot.data("slot"));
  });

  // Quantity controls
  $(document).on("click", ".sc_qty_add", function () {
    var input = $(".sc_qty_input");
    input.val(parseInt(input.val()) + 1);
  });

  $(document).on("click", ".sc_qty_sub", function () {
    var input = $(".sc_qty_input");
    if (parseInt(input.val()) > 1) {
      input.val(parseInt(input.val()) - 1);
    }
  });

  // Add to Cart — confirm details popup
  $(document).on("click", ".sc_add_to_cart", function () {
    // Ensure latest state is captured before building confirmation
    saveCurrentSideState();
    var details = "";
    if (sizeTag !== "wine") {
      details += "<p><strong>Front:</strong> ";
      var frontType = getSideType("front");
      if (frontType === "text") {
        details += 'Text: "' + scState.front.text + '" (Font: ' + scState.front.font + ")";
      } else if (frontType === "logo") {
        details += "Design: " + scState.front.logoName;
      } else if (frontType === "both") {
        details += 'Text: "' + scState.front.text + '" (Font: ' + scState.front.font + ') + Design: ' + scState.front.logoName;
      } else {
        details += "None";
      }
      details += "</p>";
    }

    details += "<p><strong>Back:</strong> ";
    var backType = getSideType("back");
    if (backType === "text") {
      details += 'Text: "' + scState.back.text + '" (Font: ' + scState.back.font + ")";
    } else if (backType === "logo") {
      details += "Design: " + scState.back.logoName;
    } else if (backType === "both") {
      details += 'Text: "' + scState.back.text + '" (Font: ' + scState.back.font + ') + Design: ' + scState.back.logoName;
    } else {
      details += "None";
    }
    details += "</p>";

    // Show the popup first so .sc_confirm_preview_thumb is actually laid out —
    // its CSS height varies by breakpoint (320px desktop, 180px on max-width:991px),
    // so we need the real rendered height before measuring below.
    $(".sc_confirm_popup").removeClass("hide");
    $(".sc_addtocart_section").addClass("hide");

    // Build bottle preview thumbnails — clone existing previews, scale down inside fixed container
    // Hide wrap entirely if that side has no customisation; strip the redundant bottom label from clone
    [['front', '.sc_front_preview'], ['back', '.sc_back_preview']].forEach(function (pair) {
      var side = pair[0], selector = pair[1];
      var $wrap = $('.sc_confirm_preview_wrap[data-side="' + side + '"]');
      var $thumb = $wrap.find('.sc_confirm_preview_thumb');
      var $source = $(selector);

      // Hide this column if no customisation on this side
      if (getSideType(side) === '' || !$source.length) {
        $wrap.addClass('hide');
        return;
      }
      $wrap.removeClass('hide');

      var $clone = $source.clone();
      $clone.find('.sc_side_label').remove(); // strip redundant bottom "Front"/"Back" label
      // Scale to whatever height the thumb container is actually rendered at
      // (varies by breakpoint — see comment above), not a hardcoded value.
      var thumbH = $thumb.outerHeight() || 320;
      var srcH = $source.outerHeight() || 580;
      var scale = thumbH / srcH;
      var srcW = $source.outerWidth() || 400;
      $clone.css({
        position: 'absolute',
        top: 0,
        left: '50%',
        transform: 'scale(' + scale + ') translateX(-50%)',
        'transform-origin': 'top left',
        width: srcW + 'px',
        'pointer-events': 'none'
      });
      $thumb.css({ position: 'relative', overflow: 'hidden', height: thumbH + 'px' }).html('').append($clone);
      // Recompute the boundary and personalization against the clone's own
      // (now-scaled) image rect — don't rely on whatever position they
      // inherited from the source.
      positionBoundaryFor($clone, $clone.find('.sc_main_image'), $clone.find('.sc_boundary'));
      positionPersonalizationFor($clone, $clone.find('.sc_main_image'), side);
    });
  });

  // Confirmation checkbox removed (11 Aug 2026) — ACCEPT is live as soon as
  // the review step shows; the non-refundable notice stays in the note above.

  // Cancel confirmation
  $(document).on("click", ".sc_cancel_btn", function () {
    $(".sc_confirm_popup").addClass("hide");
    $(".sc_addtocart_section").removeClass("hide");
  });

  // ACCEPT - Submit to cart
  $(document).on("click", ".sc_accept_btn.active", function (e) {
    e.preventDefault();
    // Final state capture before submission
    saveCurrentSideState();

    var $btn = $(this);
    // Re-click guard: the checkbox used to double as a brake — without it,
    // disable until the add resolves so a double-tap can't add twice
    $btn.attr("disabled", "disabled").removeClass("active");
    $btn.html("Loading....");

    var leftPreview = $(".sc_left_preview");
    var pricewithoutcurrency = leftPreview.attr("data-price");
    var product_title = leftPreview.attr("data-title");
    var qty = parseInt($(".sc_qty_input").val()) || 1;

    // Append active colour name to product title for engraving identification
    var activeColourName = $(".sc_colour_swatch.active").attr("data-name") || "";
    if (activeColourName) {
      var colourShort = activeColourName.split(" - ")[0];
      product_title = product_title + "- " + colourShort;
    }

    // Get variant ID - use the one from colour selection or fallback
    var var_id = scState.variantId || $(".sc_variant_data").first().attr("data-variant-id");
    var_id = parseInt(var_id);
    var customized_pd = parseInt($(".sc_data").attr("data-customized-product-id"));

    // Count customizations — text and logo are independent (max 4)
    var customQty = 0;
    if (scState.front.text)    customQty++;
    if (scState.front.logoUrl) customQty++;
    if (scState.back.text)     customQty++;
    if (scState.back.logoUrl)  customQty++;

    // Shared ID linking the main product to its engraving SKU
    var custId = Date.now().toString(36);

    // Build customization properties for the main product
    var properties = {
      _customised_product: "yes",
      "_cust_id": custId
    };

    // Front — text and logo are sent independently
    if (scState.front.text) {
      properties["FRONT ENGRAVING"] = product_title;
      properties["FRONT NAME"] = scState.front.text;
      properties["FRONT FONT"] = scState.front.font;
    }
    if (scState.front.logoUrl) {
      properties["FRONT ENGRAVING"] = product_title;
      properties["FRONT IMAGE"] = scState.front.logoUrl;
      properties["FRONT GALLERY IMAGE NAME"] = scState.front.logoName;
    }

    // Back — text and logo are sent independently
    if (scState.back.text) {
      properties["BACK ENGRAVING"] = product_title;
      properties["BACK NAME"] = scState.back.text;
      properties["BACK FONT"] = scState.back.font;
    }
    if (scState.back.logoUrl) {
      properties["BACK ENGRAVING"] = product_title;
      properties["BACK IMAGE"] = scState.back.logoUrl;
      properties["BACK GALLERY IMAGE NAME"] = scState.back.logoName;
    }

    var items = [];

    // Main product — carries all customization properties
    items.push({
      id: var_id,
      quantity: qty,
      properties: properties
    });

    // Engraving surcharge SKU — price carrier only
    if (customized_pd && !isNaN(customized_pd) && customQty > 0) {
      items.push({
        id: customized_pd,
        quantity: customQty,
        properties: {
          "_Customised Product": "yes",
          "_cust_id": custId
        }
      });
    }

    setTimeout(function () {
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: { items: items },
        dataType: "json",
        success: function () {
          $(".js-drawer-open-button-right .material-icons-outlined").trigger("click");
          $(".sc_popup").removeClass("active");
          $("body").removeClass("sc_customizer_active");
          $btn.html("ACCEPT");
          resetScUI();
        },
        error: function () {
          console.error("Error adding to cart");
          $btn.removeAttr("disabled").addClass("active");
          $btn.html("ACCEPT");
          alert("There was an error adding to cart. Please try again.");
        }
      });
    }, 1000);
  });

  // ==========================================
  // HELPER FUNCTIONS
  // ==========================================
  function syncColourFromPage() {
    // Sync from the main product page's active colour swatch
    var activeMainSwatch = $(".color_items.active");
    if (activeMainSwatch.length) {
      var colorHandle = activeMainSwatch.attr("data-color");
      var matchingSwatch = $(".sc_colour_swatch[data-color='" + colorHandle + "']");
      if (matchingSwatch.length) {
        matchingSwatch.trigger("click");
      }
    } else {
      // Default to first swatch
      $(".sc_colour_swatch").first().trigger("click");
    }
  }

  function resetScUI() {
    // Reset tabs
    $(".sc_tab").removeClass("active");
    if (sizeTag === "wine") {
      $(".sc_tab_back").addClass("active");
      $(".sc_back_preview").addClass("active");
      $(".sc_front_preview").removeClass("active");
    } else {
      $(".sc_tab_front").addClass("active");
      $(".sc_front_preview").addClass("active");
      $(".sc_back_preview").removeClass("active");
    }

    // Reset sections
    $(".sc_selection_menu").removeClass("hide");
    $(".sc_text_section").addClass("hide");
    $(".sc_gallery_section").addClass("hide");
    $(".sc_addtocart_section").addClass("hide");
    $(".sc_confirm_popup").addClass("hide");
    $(".sc_customize_section").removeClass("hide");
    $(".sc_tabs").removeClass("hide");
    $(".sc_skip_review_btn").addClass("hide");
    $(".sc_menu_review_btn").addClass("hide");
    $(".sc_outer_box").removeClass("sc_review_mode");
    if (sizeTag === "wine") {
      $(".sc_tabs").addClass("sc_tabs_single");
    }

    // Reset gallery
    $(".sc_gallery_categories").removeClass("hide");
    $(".sc_gallery_items").addClass("hide");
    $(".sc_cat_content .image").removeClass("active");

    // Reset previews
    $(".sc_text_overlay").addClass("hide");
    $(".sc_textup").html("");
    $(".sc_logo_overlay").addClass("hide");
    $(".sc_logo_img").attr("src", "");
    $(".sc_uploadingimg").hide();

    // Reset inputs
    $(".sc_text_input").val("");
    $(".sc_font_item").removeClass("active");
    $(".sc_font_item[data-font='Manderley']").addClass("active");
    $(".sc_search_input").val("");

    // Reset confirmation — no checkbox gate: ACCEPT is ready immediately
    $(".sc_accept_btn").removeAttr("disabled").addClass("active");
    $(".sc_accept_btn").html("ACCEPT");

    // Reset qty
    $(".sc_qty_input").val(1);
  }

  function goToSelectionMenu() {
    $(".sc_selection_menu").removeClass("hide");
    $(".sc_text_section").addClass("hide");
    $(".sc_gallery_section").addClass("hide");
    $(".sc_gallery_categories").removeClass("hide");
    $(".sc_gallery_items").addClass("hide");
    // Don't clear gallery active state here — it's needed by saveCurrentSideState
    // Gallery active state is cleared in resetScUI instead
    $(".sc_search_input").val("");

    // Show the Review button on the selection menu if any side has content
    var anyContent = getSideType("front") !== "" || getSideType("back") !== "";
    if (anyContent) {
      $(".sc_menu_review_btn").removeClass("hide");
    } else {
      $(".sc_menu_review_btn").addClass("hide");
    }
  }

  function saveCurrentSideState() {
    if (!$(".sc_text_section").hasClass("hide")) {
      var text = $(".sc_text_input").val().trim();
      var font = $(".sc_font_item.active").attr("data-font");
      if (text) {
        // Only update text/font — leave logoUrl/logoName intact
        scState[scState.activeSide].text = text;
        scState[scState.activeSide].font = font;
      }
    }
    if (!$(".sc_gallery_section").hasClass("hide")) {
      var activeLogo = $(".sc_cat_content .image.active");
      if (activeLogo.length) {
        // Only update logo — leave text/font intact
        scState[scState.activeSide].logoUrl = activeLogo.attr("data-texture") || activeLogo.find("img").attr("src");
        scState[scState.activeSide].logoName = activeLogo.closest(".logo-item-detail").find(".prepared-item-title").text().trim();
        scState[scState.activeSide].logoThumb = activeLogo.find("img").attr("src") || scState[scState.activeSide].logoUrl;
      }
    }
  }

  function restoreSideState(side) {
    var state = scState[side];
    var preview = side === "front" ? ".sc_front_preview" : ".sc_back_preview";

    // Text and logo overlays are shown independently — both can be visible simultaneously
    if (state.text) {
      $(preview + " .sc_text_overlay").removeClass("hide");
      $(preview + " .sc_textup").html(state.text);
      $(preview + " .sc_textup").removeClass(FONT_CLASSES).addClass("font-" + state.font);
    } else {
      $(preview + " .sc_text_overlay").addClass("hide");
    }

    if (state.logoUrl) {
      $(preview + " .sc_logo_overlay").removeClass("hide");
      $(preview + " .sc_logo_img").attr("src", state.logoUrl);
    } else {
      $(preview + " .sc_logo_overlay").addClass("hide");
    }
  }

  function updateActivePreviewText(text) {
    var activePreview = scState.activeSide === "front" ? ".sc_front_preview" : ".sc_back_preview";
    if (text) {
      $(activePreview + " .sc_text_overlay").removeClass("hide");
      $(activePreview + " .sc_textup").html(text);
      // Logo overlay is left untouched — both can show simultaneously
    } else {
      $(activePreview + " .sc_text_overlay").addClass("hide");
      $(activePreview + " .sc_textup").html("");
    }
    refreshActivePersonalization();
  }
});
